import React, { ReactElement } from 'react'
import { Grid } from '@material-ui/core';
import { useIntl } from 'react-intl';
import KTR700 from '../Clampexsets/KTR700';

export default function SelfCentering(): ReactElement {
  const { formatMessage: f } = useIntl();


  return (
    <React.Fragment>
      <h2>{f({ id: 'app.selfcent.head' })}</h2>
      <Grid container style={{ marginTop: "20px" }} justify="center">
        <Grid item>
          <KTR700/>
        </Grid>
      </Grid>
    </React.Fragment>
  )
}
